module.exports = __webpack_public_path__ + "assets/img/docs1.6b724c80.svg";